<template>
  <div  ref="scrollContainer" class="scroll-container">
    <MarketListItemComponent class="market-item" v-for="listItem in listItems" :key="listItem.id" :item="listItem" :userId="userID"/>
    <LoadingComponent :is-loading="isLoading"></LoadingComponent>

    <div v-if="hasMoreItems && !isLoading" class="load-more-container">
      <button @click="loadListings(false)" class="btn-secondary-m btn-outline_black load-more">Cargar más</button>
    </div>

     <!-- No Listings message -->
     <div v-if="listItems.length==0" class="no-listings">
          <p class="empty-results">Vaya, parece que no hay anuncios para esta búsqueda.</p>
          <router-link :to="{ name: 'create' }" class="btn-primary-m btn-primary-green" alt="¡Crea tu propio anuncio!">¡Crea tu propio anuncio!</router-link>
     </div>
  </div>
</template>

<script setup lang="ts">
import {reactive, watch, defineProps, ref, onMounted} from "vue";
import { MarketListItem } from "@/models/frontend/MarketModels";
import { searchListings } from "@/services/backend/ListingService";
import { transformListingToMarketListItem } from "@/transformers/ListingTransformer";
import MarketListItemComponent from "@/components/screens/Market/MarketListItemComponent.vue";
 import { Filter } from "@/models/frontend/FeatureModels";
import { transformFiltersToSearchCriteria } from "@/transformers/FiltersTransformer";
import LoadingComponent from "@/components/common/LoadingComponent/LoadingComponent.vue";
import { UserService } from "@/services/backend/UserService";
import * as Session from "supertokens-web-js/recipe/session";

const props = defineProps<{
  filters: Filter[],
  applyFiltersEvent: number
}>();

let listItems = reactive<MarketListItem[]>([]);
const isLoading = ref(false);
const hasMoreItems = ref(false);
const offset = ref(0);
const limit = 100;
const userID = ref<string>();

const loadListings = async (reset = false) => {
  if (isLoading.value || (!hasMoreItems.value && !reset)) return;
  isLoading.value = true;

  if (reset) {
    listItems = [];
    offset.value = 0;
    hasMoreItems.value = true;
  }

  const searchCriteria = transformFiltersToSearchCriteria(props.filters);
  searchCriteria.pagination = { limit: limit.toString(), offset: offset.value.toString() };

  const response = await searchListings(searchCriteria);
  listItems.push(...response.results.map(transformListingToMarketListItem));
  offset.value += limit;
  hasMoreItems.value = response.results.length === limit;
  isLoading.value = false;
};

onMounted(async()=>{
  const isLoggedIn = await Session.doesSessionExist();
  if(isLoggedIn){
    const response = await UserService.getUserId();
    userID.value = response;
  }

});

// Reload listings when filters change
watch(
    () => props.applyFiltersEvent,
    () => {
      loadListings(true);
    }
);

</script>

<style scoped lang="scss">
@import '@/assets/styles/mixins';

.no-listings{
    @include noListings;
};
</style>